
<div>
  <p v-if="numberOfPetsAtOneTime" class="text-grey-body text-caption mb-8">
    Willing to care for {{ numberOfPetsAtOneTime }} pets per sitting
  </p>

  <div
    v-for="(rate, index) in formattedRates"
    :key="index"
    :class="[
      'flex justify-between items-center',
      careType === 'pet_care' ? 'text-grey-body' : 'text-body',
      rate.isHeader ? 'mt-16' : 'py-8',
    ]"
  >
    <span :class="{ 'text-strong-body': rate.isHeader }">{{ rate.label }}</span>

    <span v-if="!rate.isHeader" class="text-body font-medium">
      <template v-if="isSimpleRate">
        <span class="text-h5">${{ rate.value }}{{ rate.unit }}</span>
      </template>
      <template v-else>
        <span class="caption text-grey-text-subdued align-top">$</span>
        <span class="text-h4">{{ rate.value }}</span>
        <span class="text-body text-grey-text-subdued align-top">/hr</span>
      </template>
    </span>
  </div>

  <div v-if="increasePerChildRate || numberOfChildrenAtOneTime" class="mt-16">
    <p v-if="increasePerChildRate" class="text-body mb-8">Rate per additional child – ${{ increasePerChildRate }}</p>
    <p v-if="numberOfChildrenAtOneTime" class="text-grey-body text-caption">
      Willing to care for {{ numberOfChildrenAtOneTime }} children per sitting
    </p>
  </div>
</div>
